(function (app, ng) {
  app.directive('ngInputCurrencyV2', ['$locale', function($locale) {
    // Helper for creating RegExp's
    var toRegExp = function(val) {
      var escaped = val.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      return new RegExp(escaped, 'g');
    };
    
    // Transform either a numeric value or string value into a currency formatted value
    var toCurrency = function(val) {
      if (!angular.isNumber(val) && !angular.isString(val))
        throw new TypeError('ngInputCurrencyService.toFloat expects argument to be String or Numeric, but was given ' + val);

      var inputVal = angular.isNumber(val) ? val.toString() : val;
      
      // determine if the number was negative
      var isNegative = (angular.isNumber(val) && val < 0) || (!angular.isNumber(val) && val.charAt(0) == '-');

      // strip out any '$' or ',', leave only '.' and digits
      inputVal = inputVal.replace(/[^\d.\',']/g, '');

      // Hacks off any decimal digits after the hundreths place, 0.3245 => 0.32
      var point = inputVal.indexOf(".");
      if (point >= 0) {
        inputVal = inputVal.slice(0, point + 3);
      }

      // split the input value into whole number and decimal number
      var decimalSplit = inputVal.split(".");
      var intPart = decimalSplit[0];
      var decPart = decimalSplit[1];
  
      // determine where to place the ',' for the whole number and adds ',' where needed
      intPart = intPart.replace(/[^\d]/g, '');
      if (intPart.length > 3) {
        var intDiv = Math.floor(intPart.length / 3);
        while (intDiv > 0) {
          var lastComma = intPart.indexOf(",");
          if (lastComma < 0) {
            lastComma = intPart.length;
          }
  
          if (lastComma - 3 > 0) {
            intPart = intPart.slice(0, lastComma - 3) + "," + intPart.slice(lastComma - 3);
          }
          intDiv--;
        }
      }
  
      // determines if '.' is needed 
      if (decPart === undefined) {
        decPart = "";
      } else {
        decPart = "." + decPart;
      }

      // combine negative sign (if needed) with the whole number (with commas if needed) and the decimal number
      var res = (isNegative ? "-" : "") + $locale.NUMBER_FORMATS.CURRENCY_SYM + intPart + decPart;
      return res;
    }

    // Takes a currency formatted string like "-$12,034.78" and returns a numeric value -12034.78
    var toValue = function(curr) {
      var group = toRegExp($locale.NUMBER_FORMATS.GROUP_SEP);
      var currency = toRegExp($locale.NUMBER_FORMATS.CURRENCY_SYM);

      return parseFloat(curr.replace(group, '').replace(currency, '').trim());
    }

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, $element, $attrs, $ngModel) {
  
        // Take what is the original value in the model and format for the view
        $ngModel.$formatters.push(function(value) {
          return toCurrency(value);
        });
  
        // Parse the user's input and format it to the currency format, 
        // also format the input into a numeric value for the model
        $ngModel.$parsers.push(function(value) {
          var view = toCurrency(value);
          $ngModel.$viewValue = view;
          $ngModel.$render();
          return toValue(view);
        });

        // validate and makes sure the model is a numeric value
        $ngModel.$validators.currency = function (value) {
          return angular.isNumber(value) && !isNaN(value);
        };
      }
    }

  }]);
})(window.app, window.angular); //jshint ignore:line